import { render, staticRenderFns } from "./AdBanners.vue?vue&type=template&id=669596cb&"
import script from "./AdBanners.vue?vue&type=script&lang=js&"
export * from "./AdBanners.vue?vue&type=script&lang=js&"
import style0 from "./AdBanners.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports